export default __webpack_public_path__ + "static/media/home_dataset_avatar.02070f6a.svg";